// extracted by mini-css-extract-plugin
module.exports = {"sysGrid":"sys_sysGrid__16DB_","sysKendoTab":"sys_sysKendoTab__1ftbB"};